module.exports = __webpack_public_path__ + "img/value-tip.5a4302fa.png";